import React from 'react';
import {useControllerProps} from '../Widget/ControllerContext';
import {classes} from './Footer.st.css';
import {InnerFooter} from '../../../common/components/InnerFooter/InnerFooter';

export const Footer = ({dataHook}: {dataHook: string}) => {
  const {
    loadingStatePaymentRequestSettingsStore: {
      loadingStatePaymentRequestSettings: {
        termsAndConditions,
        privacyPolicy,
        returnPolicy,
        contactUs,
        customPolicy,
        digitalPolicy,
      },
    },
    paymentRequestStore: {sendClickOnPolicyBIEvent},
  } = useControllerProps();
  return (
    <div className={classes.footer} data-hook={dataHook}>
      <InnerFooter
        termsAndConditions={termsAndConditions}
        privacyPolicy={privacyPolicy}
        returnPolicy={returnPolicy}
        digitalPolicy={digitalPolicy}
        contactUs={contactUs}
        customPolicy={customPolicy}
        shouldShowDigitalItemPolicy={true}
        onPolicyClicked={sendClickOnPolicyBIEvent}
      />
    </div>
  );
};
